import React from 'react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
export function ExtraCTAButton() {
  const scrollToCompra = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full bg-[#FDF8F3] py-8 px-4" data-id="element-87">
      <div className="max-w-3xl mx-auto text-center" data-id="element-88">
        <a href={CHECKOUT_URL} onClick={e => {
        e.preventDefault();
        scrollToCompra();
      }} className="inline-block bg-[#D4956A] hover:bg-[#C4845C] text-white text-lg font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-89">
          👉 QUIERO ESTE CAMBIO EN MI CASA
        </a>
      </div>
    </section>;
}